<template>
  <li :class="{treeview: nav.children.length > 0, active: checkIfActive(nav)}">
    <template v-if="nav.children.length === 0">
      <a @click="onClick(nav)">
        <i class="fa fa-circle-o"></i>
        <span class="page">{{nav.name}}</span>
      </a>
    </template>
    <template v-else>
      <a>
        <i class="fa fa-sitemap"></i>
        <span class="page">{{nav.name}}</span>
        <span class="pull-right-container">
          <span class="sub-indicate"></span>
        </span>
      </a>
      <ul :class="{'treeview-menu': true}">
        <template v-for="n in nav.children">
          <nav-tree :nav="n" :parent="getName()"></nav-tree>
        </template>
      </ul>
    </template>
  </li>
</template>
<script>
  export default {
    props: {
      nav: {
        required: true,
        type: Object
      },
      parent: {
        required: false,
        type: String
      },
      bus: Object
    },
    computed: {
    },
    methods: {
      select (el) {
        this.bus.$emit('select', el)
      },
      checkIfActive (nav) {
        let path = this.$route.path.split('/')
        return path[path.length - 1] === nav.name.toLowerCase().split(' ').join('-')
      },
      onClick (nav) {
        this.$store.commit('updateActivePage', nav.id)
        this.$router.push(this.parent ? `/${this.parent}/${nav.name.toLowerCase().split(' ').join('-')}` : `/${nav.name.toLowerCase().split(' ').join('-')}`)
      },
      getName () {
        return this.parent ? `${this.parent.toLowerCase().split(' ').join('-')}/${this.nav.name.toLowerCase().split(' ').join('-')}` : this.nav.name.toLowerCase().split(' ').join('-')
      }
    },
    name: "navTree"
  };
</script>
<style scoped>
  .dragArea {
    min-height: 50px;
    outline: 1px dashed;
  }
  a {
    cursor: pointer
  }
</style>
